/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Showmore1Inputs */

const zh_sidebar_showmore1 = /** @type {(inputs: Sidebar_Showmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示更多`)
};

const en_sidebar_showmore1 = /** @type {(inputs: Sidebar_Showmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show More`)
};

const es_sidebar_showmore1 = /** @type {(inputs: Sidebar_Showmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar más`)
};

/**
* | output |
* | --- |
* | "Show More" |
*
* @param {Sidebar_Showmore1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const sidebar_showmore1 = /** @type {((inputs?: Sidebar_Showmore1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Showmore1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_sidebar_showmore1(inputs)
	if (locale === "en") return en_sidebar_showmore1(inputs)
	return es_sidebar_showmore1(inputs)
});
export { sidebar_showmore1 as "sidebar_showMore" }